import context from 'static/script/app/ui/checkout2/context/context';
import util from 'static/script/app/ui/checkout2/context/util';
riot.tag2('swish-handel-payment', '<div class="co-radio-new {co-radio-selected:model.selectedPaymentType === \'SwishHandel\'}"> <div class="header" onclick="{selectPaymentType}"> <div class="cell"> <div class="checkmark"></div> </div> <div class="cell"> <div class="icon-braintree-swish"></div> </div> <div class="cell-right"> &nbsp; </div> </div> <div class="body co-inner-list"> <div class="swish-container"> <div if="{model.isAutoStartAllowed && useMobileFlow}"> <div class="swish-header">Vi öppnar Swish automatiskt!</div> <div class="swish-description">Du behöver ha Swish och BankID installerat på din mobil eller surfplatta</div> <a class="link" href="" onclick="{useOnOtherDevice}">Använd en annan enhet?</a> </div> <div if="{!model.isAutoStartAllowed || !useMobileFlow}"> <div class="swish-description"> Du behöver ha Swish och BankID installerat på din mobil eller surfplatta</div> <div> <label for="phone_number" class="swish-number-label">Mobilnummer kopplat till Swish</label> <input type="text" id="phone_number" maxlength="15" placeholder="exempel:0745010203" class="input-text swish-number-input" onkeypress="return event.charCode >= 48 && event.charCode <= 57" oninput="{validatePhoneNumber}"> </div> <div if="{model.isAutoStartAllowed}"> <div class="swish-alternative-text">eller</div> <a class="link" href="" onclick="{useOnThisDevice}">Använd Swish på den här enheten istället?</a> </div> </div> </div> </div> </div>', '', '', function(opts) {
        this.context = context;
        this.util = util;
        this.model = opts.model;

        this.phone_number.value = this.model.phoneNumber;
        this.useMobileFlow = this.model.isAutoStartAllowed;

        this.context.observable.on('payment-type-selected', function (type) {
            if (this.model.selectedPaymentType === 'SwishHandel') {
                this.validatePhoneNumber();
            }
        }.bind(this));

        this.context.observable.on('payment-failed', function (paymentFailure) {

        }.bind(this));

        this.context.observable.on('payment-requires-user-confirmation', function (paymentType, paymentResponse) {

            if (paymentType !== 'SwishHandel')
                return;

            this.modal = this.context.modal.showModal('checkout-modal',
            {
                title: 'Öppna Swish-appen',
                subTitleHtml: 'Väntar på godkännande från telefonnummer <strong style="white-space: nowrap;">' + this.phone_number.value + '</strong>',
                bodyTagName: 'swish-modal-body',
                nonDismissible: true,
                showProgressIcon: true,
                buttons: {
                    secondary: {
                        title: 'Avbryt',
                        click: function (model) {
                            this.isCanceled = true;
                            model.close();
                        }.bind(this)
                    }
                }
            });

            this.isCanceled = false;
            this.errorCount = 0;
            this.startSwishPolling(paymentResponse);

            if (this.model.isAutoStartAllowed && this.useMobileFlow && this.model.swishCallbackUrl) {
                startSwish(paymentResponse.paymentRequestToken, this.model.swishCallbackUrl);
            }

        }.bind(this));

        function startSwish(paymentRequestToken, callbackUrl) {
            window.location.href = 'swish://paymentrequest?token=' + paymentRequestToken + '&callbackurl=' + encodeURIComponent(callbackUrl);
        }

        this.useOnOtherDevice = function() {
            this.useMobileFlow = false;
            this.validatePhoneNumber();
        }

        this.useOnThisDevice = function () {
            this.useMobileFlow = true;
            this.validatePhoneNumber();
        }

        this.selectPaymentType = function () {
            if (this.model.selectedPaymentType === 'SwishHandel')
                return;

            this.context.observable.trigger('payment-type-selected', 'SwishHandel');

            this.validatePhoneNumber();
        }

        this.validatePhoneNumber = function() {

            this.setPayload();

            if (this.useMobileFlow) {
                this.context.observable.trigger('payment-valid');
            }
            else if (this.phone_number.value.length >= 8) {
                this.context.observable.trigger('payment-valid');
            }
            else
                this.context.observable.trigger('payment-not-valid');
        }

        this.setPayload = function() {
            this.context.observable.trigger('payment-set-payload',
                {
                    useMobileFlow: this.useMobileFlow,
                    swishHandelPhoneNumber: this.phone_number.value
                });
        }

        this.startSwishPolling = function (paymentResponse) {
            var self = this;

            setTimeout(function () {

                if (self.isCanceled) {
                    console.log('swish: canceled');
                    return;
                }

                self.getSwishPayment(paymentResponse.swishPollUrl)
                    .then(function (result) {
                        if (result.isFailed) {
                            self.util.serverLog({
                                error: 'Swish polling failure: ' + result.failureMessage,
                                counterName: 'swish-payment.polling-failure'
                            });
                            console.log('swish: failed or aborted');
                            self.context.observable.trigger('payment-confirmed-by-user-failed', 'SwishHandel', result.failureMessage);
                        }
                        else if (result.isPaid) {
                            console.log('swish: completed');
                            self.context.observable.trigger('payment-confirmed-by-user', 'SwishHandel', paymentResponse);
                        }
                        else {
                            self.startSwishPolling(paymentResponse);
                        }
                    })
                    .fail(function (statusText) {
                        self.util.serverLog({
                            error: 'Swish polling error: ' + statusText,
                            counterName: 'swish-payment.polling-error'
                        });
                        console.log('swish: error');
                        self.errorCount++;
                        if (self.errorCount < 3) {
                            self.startSwishPolling(paymentResponse);
                        } else {
                            self.context.observable.trigger('payment-confirmed-by-user-failed', 'SwishHandel');
                        }
                    });
            }, 2000);
        };

        this.getSwishPayment = function (swishPollUrl) {
            console.log('swish: polling...');
            var deferred = $.Deferred();

            var url = swishPollUrl + (swishPollUrl.indexOf('?') != -1 ? '&' : '?') + (new Date()).getTime();
            $.get(url)
                .done(function (data) {deferred.resolve(data);})
                .fail(function (data) {deferred.reject(data.statusText);});
            return deferred.promise();
        };

});


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/swish-handel-payment.riot.html